import { join } from 'node:path';
import { generator } from './generator.js';
import type { ComponentGeneratorOptions } from './types.js';
import { dependenciesUpdater } from './dependencies-updater.js';
import { assetsGenerator } from './assets-generator.js';

export interface ComponentGenerationResult {
  newDependencies: string[];
  newFiles: string[];
}

export async function componentGenerator(
  opts: ComponentGeneratorOptions
): Promise<ComponentGenerationResult> {
  const { template, projectFolder, assetsOutputPath, ...generatorOpts } = opts;

  const newFiles = await generator({
    ...generatorOpts,
    template: join(template, 'files'),
  });

  await assetsGenerator({
    templateRoot: template,
    projectFolder,
    outputPath: assetsOutputPath,
  });

  const newDependencies = await dependenciesUpdater({
    projectFolder,
    dependenciesJsonPath: join(template, 'dependencies.json'),
    ...(opts.importData?.packageName
      ? {
          dynamicPackages: { [opts.importData.packageName]: '^1.0.0' },
        }
      : {}),
  });

  return { newDependencies, newFiles };
}
